import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImages3"><Path d="M14.25 7C13.1454 7 12.25 7.89543 12.25 9C12.25 10.1046 13.1454 11 14.25 11C15.3546 11 16.25 10.1046 16.25 9C16.25 7.89543 15.3546 7 14.25 7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM8 10.5858L5 13.5858V5H19V17.5858L14 12.5858L12 14.5858L8 10.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages3;
